import {RealDevice} from "dto/realdevice/devices"
import {useFindPathTrackingByEuiAndDate} from "hooks/queries/path-tracking.query"
import {useEffect, useMemo, useState} from "react"
import {isValidStringCoordinate} from "utils/coordinate-validator"

export type MapType = "ROADMAP" | "SKYVIEW" | "HYBRID" | "TRAFFIC" | "USE_DISTRICT" | "TERRAIN"
export interface Path {
    lat: number
    lng: number
    no: number
}
export const useKakaoMap = (selectedDevice: RealDevice | null | undefined, map: kakao.maps.Map | undefined) => {
    const [mapType, setMapType] = useState<MapType>("ROADMAP")
    const {data: pathTracking} = useFindPathTrackingByEuiAndDate()
    useEffect(() => {
        if (!map) return
        map.setMapTypeId(kakao.maps.MapTypeId[mapType])
    }, [map, mapType])

    useEffect(() => {
        if (!selectedDevice || !map || !isValidStringCoordinate(selectedDevice.communicationDevice?.currentLatLng)) return
        const latLng = new kakao.maps.LatLng(
            parseFloat(selectedDevice.communicationDevice.currentLatLng!.lat!),
            parseFloat(selectedDevice.communicationDevice.currentLatLng!.lng!)
        )
        map.panTo(latLng)
    }, [map, selectedDevice])


    const changeMapType = (mapType: MapType) => {
        setMapType(mapType)
    }

    // const mapRelayout = () => {
    //     if (!map) return
    //     map.relayout()
    // }

    // const pathList = pathTracking?.content.map<Path>((path, idx) => ({lat: path?.lat || 0, lng: path.lng || 0, no: idx + 1})) || undefined

    const pathList = useMemo<Path[]>(() => {
        return pathTracking?.content.map((path, idx) => ({lat: path?.lat || 0, lng: path.lng || 0, no: idx + 1})) || []
    }, [pathTracking])
    return {
        mapType,
        pathTrackingList: pathList,
        changeMapType,
    }
}